<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('user_auth_title') }}
          <span v-if="userInfo" style="color:#1838d9"> ({{ userInfo.name }}) </span>
        </h3>

        <a-button type="primary" @click="() => this.$router.go(-1)" icon="double-left">
          {{ $t('com_btn_back') }}
        </a-button>
      </div>
    </div>
    <div class="g-content-main common-filter-main">
      <div class="user-form" v-if="userInfo">
        <a-form-model
          :model="form"
          :rules="formRules"
          ref="formElement"
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          style="width:750px;"
        >
          <!-- 用户名 -->
          <a-form-model-item :label="$t('user_auth_role')" style="margin-bottom:0px;">
            <div>{{ roleAuth.name }}</div>
          </a-form-model-item>

          <!-- 所属客户 -->
          <!-- <a-form-model-item
          label="Customer"
          v-if="currentCustomer"
          style="margin-bottom:0px;"
        >
          <div>{{ currentCustomer.name }}</div>
        </a-form-model-item> -->

          <!-- 客户授权 -->
          <a-form-model-item
            :label="$t('user_auth_customer_site_label')"
            prop="customerNameList"
            style="margin-bottom:0"
          >
            <div class="authorization-list">
              <div class="authorization-box">
                <Loading
                  v-if="loading"
                  :show="loading"
                  style="height:100px;padding:0;margin:0;"
                  :text="null"
                />
                <div v-else>
                  <a-tree
                    checkable
                    @check="checkCustomer"
                    @select="
                      (_selectedKeys, event) => {
                        onSelect(event, _selectedKeys);
                      }
                    "
                    defaultExpandAll
                    checkStrictly
                    :show-icon="true"
                    v-model="checkedKeyList"
                    v-if="dataList && dataList.length"
                  >
                    <!-- <a-icon slot="icon" type="MenuFoldOutline" /> -->
                    <a-tree-node
                      :key="customer.key"
                      v-for="customer in dataList"
                      :disabled="customer.disabled"
                    >
                      <Icon
                        slot="icon"
                        type="menu_customer"
                        style="opacity:0.6;position:relative;top:2px;"
                      />
                      <span
                        slot="title"
                        style="color: #e91e63;text-align:left;padding:0;"
                        :title="`Customer: ${customer.title}`"
                      >
                        {{ customer.title }}
                      </span>
                      <a-tree-node
                        :key="site.key"
                        v-for="site in customer.children"
                        :disabled="site.disabled"
                      >
                        <Icon
                          slot="icon"
                          type="station"
                          style="opacity:0.6;position:relative;top:2px;"
                        />
                        <span slot="title" style="color: #333">
                          {{ site.title }}
                        </span>
                      </a-tree-node>
                    </a-tree-node>
                  </a-tree>
                  <Empty v-else style="height:200px;" />
                </div>
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item label=" " :colon="false" style="margin-bottom:0">
            <!-- 错误描述 -->
            <div class="form-error-text">
              <Icon type="error" v-if="formError" />
              <p>{{ formError }}</p>
            </div>
          </a-form-model-item>

          <!-- 拥有所有customer权限时，没有保存按钮 -->
          <a-form-model-item
            label=" "
            :colon="false"
            style="margin-bottom:0"
            v-if="roleAuth.customerRangeLevel !== 0"
          >
            <a-button type="primary" @click="handleSubmit" style="width:100px">
              {{ $t('com_btn_save') }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/user';
import * as CustomerAPI from '@/api/system/customer';
import cusomterMixin from '@/mixins/customer';
import CustomerIcon from '@/assets/icon/menu_customer.svg';

export default {
  mixins: [cusomterMixin],
  data() {
    return {
      loading: true,
      CustomerIcon,
      form: {
        customerList: undefined,
        stationList: undefined,
      },
      formRules: {},

      // 客户
      customerList: [],
      customerObject: {},
      customerSelected: [],
      // 用户信息
      userInfo: null,
      roleAuth: null,

      // 用户id
      id: null,
      formError: '',

      // 站点列表
      stationList: [],
      siteSelected: [],

      // tree
      dataList: [],

      // 选中
      checkedKeyList: [],
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    // 先获取form需要的数据
    this.getFormData();
  },
  methods: {
    // 先获取表单数据
    getFormData() {
      const apiList = [
        // 获取所有客户
        this.getUserInfo(),
      ];

      this.loading = true;
      Promise.all(apiList).finally(() => {
        // 当前客户
        this.getCurrentCustomer(this.userInfo.customerId);

        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 编辑时获取用户数据
    getUserInfo() {
      return API.UserDetail({ userId: this.id }).then(res => {
        if (res.code === 0) {
          this.userInfo = res.data.userInfo;
          this.roleAuth = res.data.userAuth;

          if (this.userInfo) {
            if (this.userInfo.customerList) {
              // customer是否选择了全部
              // 非全部的时候，才用下面的筛选
              if (this.roleAuth.customerRangeLevel !== 0) {
                this.customerSelected = JSON.parse(this.userInfo.customerList).map(
                  item => `c__${item}`
                );

                // site是否选择所有
                if (this.roleAuth.stationRangeLevel !== 0) {
                  if (this.userInfo.stationList) {
                    this.siteSelected = JSON.parse(this.userInfo.stationList)
                      .map(item => item.stationId)
                      .map(item => `s__${item}`);
                  }
                }
              }
            }

            // 初始选中的客户/站点
            this.checkedKeyList = [].concat(this.customerSelected).concat(this.siteSelected);
          }
          // 表单
          this.form.roleId = this.userInfo.roleId;

          // 获取所有客户及site
          this.getAllCustomerList();
        }
      });
    },

    //  - error reset
    formInput() {
      this.formError = '';
    },

    // 提交
    handleSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.$confirm({
            title: this.$t('user_confirm_save_title'),
            centered: true,
            onOk: () => {
              this.$store.commit('setFreeze', this.$t('com_ongoing_save'));

              // 计算客户的id
              const customerSelectedIds = [];
              this.checkedKeyList.forEach(key => {
                if (/c__/gi.test(key)) {
                  customerSelectedIds.push(key.replace('c__', ''));
                }
              });

              // 计算站点的id
              const stationSelectedIds = [];
              this.stationList.map(item => {
                if (this.checkedKeyList.includes(`s__${item.stationId}`)) {
                  stationSelectedIds.push({
                    customerId: item.customerId,
                    stationId: item.stationId,
                  });
                }
              });
              // return;

              // 参数
              const params = {
                customerList: customerSelectedIds,
                stationList: stationSelectedIds,
                userId: this.id,
              };

              API.UserAuthSave(params)
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success(this.$t('com_msg_save_success'));

                    this.$router.push({ name: 'UserList' });
                  } else {
                    this.formError = res.message;
                  }
                })
                .finally(() => {
                  this.$store.commit('setFreeze', false);
                });
            },
          });
        }
      });
    },

    // 查询当前用户下的站点列表
    getAllCustomerList() {
      const params = {};
      return CustomerAPI.CustomerSelect(params).then(res => {
        if (res.code === 0) {
          const temp = [];
          const temp_obj = {};
          (res.data || []).forEach(element => {
            const _item = {
              key: `c__${element.customerId}`,
              title: element.name,
              customerId: element.customerId,
            };

            // 所有客户权限
            if (this.roleAuth.customerRangeLevel === 0) {
              this.checkedKeyList.push(_item.key);
              _item.disabled = true;
            }

            temp.push(_item);
            temp_obj[element.customerId] = element;
          });
          this.customerList = temp;
          this.customerObject = temp_obj;

          this.getAllSiteList();
        }
      });
    },

    // 获取site 列表
    getAllSiteList() {
      const params = {
        customerIds: this.customerList.map(item => item.customerId).join(','),
      };
      return API.UserAuthSites(params)
        .then(res => {
          this.stationList = res.data || [];

          this.customerList.forEach(item => {
            item.children = [];
            (res.data || []).forEach(element => {
              if (element.customerId === item.customerId) {
                const _item = {
                  key: `s__${element.stationId}`,
                  title: `${element.name}`,
                  stationId: element.stationId,
                };

                // 所有站点权限，则有站点的客户也选中
                if (this.roleAuth.stationRangeLevel === 0) {
                  if (!this.checkedKeyList.includes(item.key)) {
                    this.checkedKeyList.push(item.key);
                  }
                  this.checkedKeyList.push(_item.key);
                }
                // 所有客户权限，禁用站点选择
                if (this.roleAuth.customerRangeLevel === 0) {
                  _item.disabled = true;
                }

                item.children.push(_item);
              }
            });
          });

          // tree data
          this.dataList = this.customerList;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // check
    checkCustomer(checkedKeys, e) {
      const currentValue = e.node.eventKey;
      this.checkedKeyList = checkedKeys.checked;

      // 如果site选择，他的父级（customer必须选择）
      // 但是Customer选中，不一定要选site
      if (currentValue && /s__/gi.test(currentValue)) {
        const currentStaionId = currentValue.replace('s__', '');
        const currentStaion = this.stationList.find(item => item.stationId === currentStaionId);

        if (e.checked) {
          // 查看父级customer是否有选择
          if (!this.checkedKeyList.includes(currentStaion.customerId)) {
            this.checkedKeyList.push(`c__${currentStaion.customerId}`);
          }
        }
      }

      // 如果customer
      if (currentValue && /c__/gi.test(currentValue)) {
        const currentCustomerId = currentValue.replace('c__', '');
        const currentCustomer = this.customerList.find(
          item => item.customerId === currentCustomerId
        );

        // 当前customer下的所有staiton
        const allStations = currentCustomer.children.map(item => item.key);

        // 如果customer勾选，那下面所有site都勾选
        if (e.checked) {
          this.checkedKeyList = this.checkedKeyList.concat(allStations);
        } else {
          const newCheckedList = [];
          this.checkedKeyList.forEach(key => {
            if (!allStations.includes(key) && key !== currentValue) {
              newCheckedList.push(key);
            }
          });
          this.checkedKeyList = newCheckedList;
        }
      }

      // 去重
      this.checkedKeyList = Array.from(new Set(this.checkedKeyList));
    },

    // 选择
    onSelect(event, _selectedKeys) {
      this.$nextTick(() => {
        if (event.node && event.node.$el && event.node.$el.children && event.node.$el.children[1]) {
          event.node.$el.children[1].click();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .user-form {
  max-width: 1000px;
  width: 100%;

  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-form-item-label {
    label {
      color: #aaa;
    }
  }
}

.authorization-list {
  display: flex;
  // width: 600px;
  margin-bottom: 20px;
  // height: 400px;
  padding-top: 10px;
  .authorization-box {
    // width: 100%;
    margin-right: 20px;
    height: 100%;
    border: #eee solid 1px;
    border-radius: 5px;
    padding: 10px 20px 10px 10px;
    min-width: 100px;

    h3 {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-bottom: #eee solid 1px;
      background: #f9f9f9;
      border-radius: 5px 5px 0 0;
    }

    .authorization-box-content {
      width: 100%;
      margin-right: 20px;
      height: 100%;
      overflow: auto;
    }
  }
}

.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
